import { GetDataPayloadT } from 'business/definitions';
import { snakify, camelize } from 'helpers/syntaxHelper';
import { transformUrlParams } from 'helpers/urlHelpers';

/**
 * Middleware meant to be used as a PreProcessingUrlCallback into APIClient.
 * Deals specifically with get_data queries, by snakifying all values
 * passed into query params for dimensions, dimensions_to_pivot, filters and metrics.
 */
export const getDataPreProcessingUrlMiddleware = (endpoint: string): string => {
    const KEYS_REQUIRING_VALUES_SNAKIFICATION = [
        'dimensions',
        'dimensions_to_pivot',
        'filters',
        'metrics',
        'budget_by',
    ];

    return transformUrlParams(
        endpoint,
        KEYS_REQUIRING_VALUES_SNAKIFICATION,
        snakify,
    );
};

/**
 * Middleware meant to be used as a PostProcessingCallback into APIClient.
 * Deals specifically with get_data fetch payloads, by camelizing values
 * in data.columns.
 */
export const getDataPostProcessingMiddleware = ({
    data: { columns, data },
}: GetDataPayloadT): GetDataPayloadT => {
    const updatedColumns = columns.map((col) => ({
        ...col,
        key: camelize(col.key),
    }));
    return {
        data: { columns: updatedColumns, data },
    };
};
